import client, { axiosBaseUrl } from './client';
import { WoocommerceApi } from 'woofwoof-api';

export const woocommerceApi = new WoocommerceApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);

// Type for recommended products to be attached to visit
export interface RecommendedProduct {
  id: number;
  name: string;
  permalink: string;
  price: string;
  images: Array<{ src: string }>;
  description?: string;
}
